import { BEREICHE_BY_ANBAUGEBIET } from './regionsAndBereiche.js';

// Color per Anbaugebiet. Used both for the region polygons in Mode 1 and
// for region-zoom vineyards in Mode 3.
export const REGION_COLORS = {
  'Ahr':                  '#b91c5c',
  'Mittelrhein':          '#7c3aed',
  'Mosel':                '#0ea5b7',
  'Nahe':                 '#65a30d',
  'Rheingau':             '#d97706',
  'Rheinhessen':          '#dc2626',
  'Pfalz':                '#9333ea',
  'Hessische Bergstraße': '#f59e0b',
  'Franken':              '#16a34a',
  'Württemberg':          '#0369a1',
  'Baden':                '#be123c',
  'Saale-Unstrut':        '#ea580c',
  'Sachsen':              '#0d9488'
};

export const UNCLASSIFIED_COLOR = '#6b7280';
export const NOTABLE_GOLD = '#d4a017';
export const VILLAGE_COLOR = '#d97706';
export const PRODUCER_COLOR = '#d946ef';
// Reserved for VDP-GG-not-GWS vineyards; kept out of the bereich palette below.
export const VDP_GG_BLACK = '#111111';

export function colorForRegion(name) {
  return REGION_COLORS[name] ?? UNCLASSIFIED_COLOR;
}

// Distinct hues for bereiche within a single region view.
// Uses a palette of 12 saturated pastels that stay legible on a light map.
// No near-black entries here — black is reserved for VDP-GG-not-GWS vineyards.
// (idx 3 was #3a3a3a, e.g. Baden's Kaiserstuhl; idx 10 was #4a4a4a.)
const BEREICH_PALETTE = [
  '#9f86c0', '#457b9d', '#2a9d8f', '#d1495b', '#8b5e3c',
  '#3da35d', '#6a4c93', '#1982c4', '#c45baa', '#ff595e',
  '#577590', '#5c4033'
];

const bereichColorCache = {};

// Manual overrides for bereiche whose palette color clashes with the region color
const BEREICH_COLOR_OVERRIDES = {
  'Württemberg::Bayerischer Bodensee':      '#e63946',  // red
  'Württemberg::Kocher-Jagst-Tauber':      '#9f86c0',  // light purple
  'Württemberg::Neckar-Alb':               '#2a9d8f',  // teal
  'Württemberg::Remstal':                  '#8b5e3c',  // brown
  'Württemberg::Württembergisch Unterland': '#c45baa',  // pink
  'Württemberg::Württembergischer Bodensee': '#457b9d', // steel blue
};

export function colorForBereich(bereich, anbaugebiet) {
  if (!bereich) return UNCLASSIFIED_COLOR;
  const key = `${anbaugebiet}::${bereich}`;
  if (bereichColorCache[key]) return bereichColorCache[key];

  // Check manual overrides first
  if (BEREICH_COLOR_OVERRIDES[key]) {
    bereichColorCache[key] = BEREICH_COLOR_OVERRIDES[key];
    return BEREICH_COLOR_OVERRIDES[key];
  }

  // Try static list first for stable ordering
  const list = BEREICHE_BY_ANBAUGEBIET[anbaugebiet] ?? [];
  let idx = list.indexOf(bereich);
  // Fallback: hash the name to pick a palette color for bereiche not in the static list
  if (idx < 0) {
    let h = 0;
    for (let i = 0; i < bereich.length; i++) h = ((h << 5) - h + bereich.charCodeAt(i)) | 0;
    idx = Math.abs(h);
  }
  const color = BEREICH_PALETTE[idx % BEREICH_PALETTE.length];
  bereichColorCache[key] = color;
  return color;
}
